import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconName, IconSize } from '@panaya/ui/p-icon';
import { ColorName } from '@panaya/ui/styles-to-code';
import { getAutomationId } from '@panaya/utils';
import { SvgIconName } from '@panaya/ui/p-icon';
import { CustomSvgIconName } from '@panaya/ui/p-icon/customize';

@Component({
    selector: 'p-action-button',
    templateUrl: './p-action-button.component.html',
    styleUrls: ['./p-action-button.component.scss']
})
export class PActionButtonComponent implements OnInit {
    @Input() public label = '';
    @Input() public isSentenceCase = true;
    @Input() public disabled = false;
    @Input() public iconBeforeName?: IconName;
    @Input() public imageBeforeName?: SvgIconName | CustomSvgIconName;
    // TODO: (p-action-button): Action button has rules for design and behavior. Icon size and color should be set by the component, not from the outside.
    @Input() public iconBeforeSize!: IconSize;
    @Input() public iconBeforeColor!: ColorName;
    @Input() public isMenuTrigger = false;
    @Input() public isRight = false;
    @Input() public isStandalone = true;
    @Input() public isActive = false;
    @Input() public tooltip = '';
    @Input() public buttonType: HTMLButtonElement['type'] = 'submit';

    @Output() public readonly buttonClicked: EventEmitter<MouseEvent> = new EventEmitter();

    public automationId = '';

    constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

    /**
     * Suppress the tooltip when this button has been relocated into an overflow menu (the responsive toolbar's
     * "More" popover, marked `.p-overflow-menu`): there the label is already shown, and a hover tooltip would
     * overlap the menu.
     */
    public get isInOverflowMenu(): boolean {
        return !!this.elementRef.nativeElement.closest('.p-overflow-menu');
    }

    public ngOnInit(): void {
        this.automationId = getAutomationId('p-button', this.label, this.iconBeforeName ?? this.imageBeforeName);
    }

    public onClick($event: MouseEvent): void {
        if (this.isMenuTrigger) {
            this.isActive = true;
        }
        this.buttonClicked.emit($event);
    }
}
